export default __webpack_public_path__ + "static/media/errorHandler.dba3e1df.png";